<div class="main-container">
    <div class="main-page">
        <div class="prospect-detail"> 
            <div class="d-grid grid-prospect gap-32"> 
                @if(presupuesto?.nombre_presupuesto){
                    <div>
                        <div class="prospect-card"> 
                            <div class="d-grid prospect-title"> 
                                <div><h4 class="color-gray t-20">Presupuesto</h4></div> 
                                <div class="d-grid card-buttons-1 align-self-end">

                                    <div class="menu-container">
                                        <div class="btn-group "> 
                                        <button class="action-btn primary d-flex align-items-center" style=" height: 38px; border-radius: 16px;" (click)="generarPDF()">
                                         Generar PDF
                                        </button>                                   
                                        <div class="dropdown-container" (click)="$event.stopPropagation()">                      
                                            <button (click)="toggleActionsMenu('menu-'+ presupuesto.presupuesto_id)" class="btn btn-round-outline">
                                                <img src="assets/svg/tridots.svg" class="center-svg">
                                            </button>
                                            <div class="dropdown-menu" [class.show]="openedMenuId === 'menu-'+ presupuesto.presupuesto_id ">
                                                <button class="dropdown-item" >Enviar presupuesto por correo</button>
                                                <button *ngIf="permissionService.hasPermission('Presupuestos', 'editar')" class="dropdown-item" (click)="updateBudget(presupuesto)" >Modificar</button>
                                                <button *ngIf="permissionService.hasPermission('Presupuestos', 'Eliminar')" class="dropdown-item" (click)="openMdlDeleteBudget()">Eliminar</button>
                                                <button class="dropdown-item" (click)="openMdlCreateContact()">Nuevo contacto</button>
                                                <button *ngIf="permissionService.hasPermission('Prospectos', 'Crear')" class="dropdown-item" (click)="openMdlCreateProspect()">Nuevo prospecto</button> 
                                                
                                            </div>
                                        </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div>
                                <div class="d-grid prospect-name"> 
                                    <div><img src="assets/svg/money-icon.svg" alt=""></div>
                                    <div><h2 class="text-semibold">{{presupuesto.nombre_presupuesto}}</h2></div>
                                </div>
                                <div class="d-flex flex-row gap-20">
                                    <div class="text-tag color-org text-center"><b>Última actualización:</b> 13/09/2025</div>
                                </div>
                                <div class="d-grid card-buttons-2">
                                    <div class="text-center event-item">
                                        <button class="btn btn-round-outline" (click)="openNewCall()"><img class="center-svg" src="assets/svg/call-icon.svg"></button>
                                        <h5>Llamada</h5>
                                    </div>
                                    <div class="text-center event-item">
                                        <button class="btn btn-round-outline" (click)="openNewTask()"><img class="center-svg" src="assets/svg/task-icon.svg"></button>
                                        <h5>Tarea</h5>
                                    </div>
                                    <div class="text-center event-item">
                                        <button class="btn btn-round-outline" (click)="openNewEvent()"><img class="center-svg" src="assets/svg/event-icon.svg"></button>
                                        <h5>Evento</h5>
                                    </div>
                                    <div class="text-center event-item">
                                        <button class="btn btn-round-outline" (click)="openSendMail()"><img class="center-svg" src="assets/svg/mail-icon.svg"></button>
                                        <h5>Correo</h5>
                                    </div>
                                </div>

                                <div class="info-card">
                                    <div class="d-grid info-card-title">
                                        <h3>Información del presupuesto</h3>
                                        <div class="d-grid card-buttons-1">
                                            <div *ngIf="!editBudgetInfo"><img src="assets/svg/edit.svg" alt="editar" class="icon-clickable" (click)="toggleEdit('budgetInfo')"></div>
                                             <div *ngIf="editBudgetInfo" class="d-flex gap-10">
                                            <button class="btn btn-primary" (click)="saveSection('budgetInfo')">
                                            Guardar
                                            </button>
                                            <button class="btn btn-outline" (click)="cancelEdit('budgetInfo')">
                                            Cancelar
                                            </button>
                                        </div>
                                            <div class="d-grid"><button class="btn btn-round-outline-mini" (click)="toggleSection('budgetInfo')"><img class="center-svg" [class.rotated]="!showBudgetInfoSection" src="assets/svg/arrow-up.svg"></button></div>
                                        </div>
                                    </div>
                                    <div class="info-card-detail" *ngIf="showBudgetInfoSection">
                                        <table class="info-table">
                                            <tbody>
                                                <tr>
                                                    <td>Numero del presupuesto:</td>
                                                    <td>
                                                    <ng-container *ngIf="!editBudgetInfo; else editNombre">
                                                    {{ presupuesto.numero_presupuesto || 'Sin asignar' }}
                                                    </ng-container>
                                                    <ng-template #editNombre>
                                                    <input
                                                        class="crm-input"
                                                        type="text"
                                                        [(ngModel)]="editableBudget.nombre_presupuesto"
                                                    />
                                                    </ng-template>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>Fecha de caducidad:</td>
                                                <td>
                                                    <ng-container *ngIf="!editBudgetInfo; else editFecha">
                                                    {{ presupuesto.fecha_caducidad | date: 'dd/MM/yyyy' }}
                                                    </ng-container>
                                                    <ng-template #editFecha>
                                                    <input
                                                        class="crm-input"
                                                        type="date"
                                                        [(ngModel)]="editableBudget.fecha_caducidad"
                                                    />
                                                    </ng-template>
                                                </td>
                                            </tr>
                                                <tr>
                                                    <td>Nombre de la oportunidad:</td>
                                                    <td>{{presupuesto.oportunidades?.nombre}}</td>
                                                </tr>
                                                <tr>
                                                    <td>nombre de la cuenta:</td>
                                                    <td>{{presupuesto.contacto?.cuenta?.nombre_empresa}}</td>   
                                                </tr>
                                                <tr>
                                                    <td>Total:</td>
                                                    <td>
                                                        {{presupuesto.precio_total}}
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>

                                <div class="info-card mt-4">
                                    <div class="d-grid info-card-title">
                                        <h3>Información adicional</h3>
                                        <div class="d-grid card-buttons-1">
                                            <div *ngIf="!editExtra"><img src="assets/svg/edit.svg" alt="editar" class="icon-clickable" (click)="toggleEdit('extra')"></div>
                                                  <div *ngIf="editExtra" class="d-flex gap-10">
                                                <button class="btn btn-primary" (click)="saveSection('extra')">
                                                Guardar
                                                </button>
                                                <button class="btn btn-outline" (click)="cancelEdit('extra')">
                                                Cancelar
                                                </button>
                                            </div>

                                            <div class="d-grid"><button class="btn btn-round-outline-mini" (click)="toggleSection('extra')"><img class="center-svg" [class.rotated]="!showExtraSection" src="assets/svg/arrow-up.svg"></button></div>
                                        </div>
                                    </div>
                                    <div class="info-card-detail" *ngIf="showExtraSection">
                                        <table class="info-table">
                                            <tbody>
                                                <tr>
                                                    <td>Nombre del presupuesto :</td>
                                                    <td>
                                                        <ng-container *ngIf="!editExtra; else editNombre">
                                                        {{ presupuesto.nombre_presupuesto }}
                                                        </ng-container>
                                                        <ng-template #editNombre>
                                                        <input
                                                            class="crm-input"
                                                            type="text"
                                                            [(ngModel)]="editableBudget.nombre_presupuesto"
                                                        />
                                                        </ng-template>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Estado:</td>
                                                    <td>{{presupuesto.estado?.nombre || 'Sin definir'}}</td>
                                                </tr>
                                                <tr>
                                                    <td>descripcion:</td>
                                                    <td>
                                                        <ng-container *ngIf="!editExtra; else editDescripcion">
                                                        {{ presupuesto.descripcion }}
                                                        </ng-container>
                                                        <ng-template #editDescripcion>
                                                        <textarea
                                                            class="crm-input"
                                                            [(ngModel)]="editableBudget.descripcion"
                                                            rows="2"
                                                        ></textarea>
                                                        </ng-template>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Divisa de presupuesto:</td>
                                                     <td>
                                                        <ng-container *ngIf="!editExtra; else editDivisa">
                                                        {{ presupuesto.divisa_presupuesto }}
                                                        </ng-container>
                                                        <ng-template #editDivisa>
                                                        <select
                                                            class="crm-input"
                                                            [(ngModel)]="editableBudget.divisa_presupuesto"
                                                        >
                                                            <option value="CLP">CLP</option>
                                                            <option value="USD">USD</option>
                                                            <option value="EUR">EUR</option>
                                                        </select>
                                                        </ng-template>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>

                                <div class="info-card mt-4">
                                    <div class="d-grid info-card-title">
                                        <h3>Totales</h3>
                                        <div class="d-grid card-buttons-1">
                                            <div *ngIf="!editTotals"><img src="assets/svg/edit.svg" alt="editar" class="icon-clickable" (click)="toggleEdit('totals')"></div>
                                            <div *ngIf="editTotals" class="d-flex gap-10">
                                                <button class="btn btn-primary" (click)="saveSection('totals')">
                                                Guardar
                                                </button>
                                                <button class="btn btn-outline" (click)="cancelEdit('totals')">
                                                Cancelar
                                                </button>
                                            </div>
                                            <div class="d-grid"><button class="btn btn-round-outline-mini" (click)="toggleSection('totals')"><img class="center-svg" [class.rotated]="!showTotalsSection" src="assets/svg/arrow-up.svg"></button></div>
                                        </div>                                        
                                    </div>
                                    <div class="info-card-detail" *ngIf="showTotalsSection" style="grid-template-columns: 1fr 1fr; column-gap: 32px;">
                                        <div>
                                        <table class="info-table">
                                            <tbody>
                                                <tr>
                                                    <td>Subtotal:</td>
                                                    <td>{{presupuesto.divisa_presupuesto}} {{presupuesto.subtotal}}</td>
                                                    <td>Impuestos</td>
                                                    <td>{{presupuesto.divisa_presupuesto}} {{presupuesto.impuestos}}</td>
                                                </tr>
                                                <tr>
                                                    <td>Descuento:</td>
                                                     <td>
                                                    <ng-container *ngIf="!editTotals; else editDescuento">
                                                        {{ presupuesto.descuento_global || 0 }}%
                                                    </ng-container>
                                                    <ng-template #editDescuento>
                                                    <div class="inline-input">
                                                        <input
                                                        class="crm-input compact"
                                                        type="number"
                                                        min="0"
                                                        max="100"
                                                        [(ngModel)]="editableBudget.descuento_global"
                                                        />
                                                        <span class="suffix">%</span>
                                                    </div>
                                                    </ng-template>
                                                    </td>
                                                    <td>Costo de envio:</td>
                                                     <td>
                                                    <ng-container *ngIf="!editTotals; else editEnvio">
                                                        {{ presupuesto.divisa_presupuesto }}
                                                        {{ presupuesto.envio || 0 | number: '1.0-0' }}
                                                    </ng-container>
                                                    <ng-template #editEnvio>
                                                    <div class="inline-input">
                                                        <span class="prefix">{{ presupuesto.divisa_presupuesto }}</span>
                                                        <input
                                                        class="crm-input compact"
                                                        type="number"
                                                        min="0"
                                                        [(ngModel)]="editableBudget.envio"
                                                        />
                                                    </div>
                                                    </ng-template>
                                                    </td>                                                    
                                                </tr>
                                                <tr>
                                                    <td><b>Total:</b></td>
                                                    <td colspan="3">
                                                    <b>{{ presupuesto.divisa_presupuesto }} {{ presupuesto.precio_total | number:'1.0-0' }}</b>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                        </div>  
                                    </div>
                                </div>
                                
                                <div class="info-card mt-4">
                                    <div class="d-grid info-card-title">
                                        <h3>Preparado por</h3>
                                        <div class="d-grid card-buttons-1">
                                            <div class="d-grid"><button class="btn btn-round-outline-mini" (click)="toggleSection('prepared')" ><img class="center-svg" [class.rotated]="!showPreparedSection" src="assets/svg/arrow-up.svg"></button></div>
                                        </div>
                                    </div>
                                    <div class="info-card-detail" *ngIf="showPreparedSection">
                                        <table class="info-table">
                                            <tbody>
                                                <tr>
                                                    <td>Nombre del contacto:</td>
                                                    <td>
                                                        <div class="d-flex flex-row align-items-center color-org">
                                                        <u>{{presupuesto.contacto?.nombre}} {{presupuesto.contacto?.apellido}}</u>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Telefono:</td>
                                                    <td>{{presupuesto.contacto?.telefono}}</td>
                                                </tr>
                                                <tr>
                                                    <td>Correo:</td>
                                                    <td>{{presupuesto.contacto?.email}}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>

                                <div class="info-card mt-4">
                                    <div class="d-grid info-card-title">
                                        <h3>Información de envío</h3>
                                        <div class="d-grid card-buttons-1">
                                            <div *ngIf="!editShipping"><img  src="assets/svg/edit.svg" alt="editar" class="icon-clickable" (click)="toggleEdit('shipping')"></div>
                                            <div *ngIf="editShipping" class="d-flex gap-10">
                                                <button class="btn btn-primary" (click)="saveSection('shipping')">
                                                Guardar
                                                </button>
                                                <button class="btn btn-outline" (click)="cancelEdit('shipping')">
                                                Cancelar
                                                </button>
                                            </div>
                                            <div class="d-grid"><button class="btn btn-round-outline-mini"(click)="toggleSection('shipping')" ><img class="center-svg" [class.rotated]="!showShippingSection" src="assets/svg/arrow-up.svg"></button></div>
                                        </div>
                                    </div>
                                    <div class="info-card-detail" *ngIf="showShippingSection">
                                        <table class="info-table">
                                            <tbody>
                                                <tr>
                                                   <td>Nombre de facturación:</td>
                                                   <td>
                                                        <ng-container *ngIf="!editShipping; else editNombreFact">
                                                        {{ presupuesto.nombre_fact || '—' }}
                                                        </ng-container>
                                                        <ng-template #editNombreFact>
                                                        <input
                                                            class="crm-input"
                                                            type="text"
                                                            [(ngModel)]="editableBudget.nombre_fact"
                                                        />
                                                        </ng-template>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Dirección de facturación:</td>
                                                    <td>
                                                        <ng-container *ngIf="!editShipping; else editCalleFact">
                                                        {{ presupuesto.calle_fact || '—' }}
                                                        </ng-container>
                                                        <ng-template #editCalleFact>
                                                        <input
                                                            class="crm-input"
                                                            type="text"
                                                            [(ngModel)]="editableBudget.calle_fact"
                                                        />
                                                        </ng-template>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Nombre envio:</td>
                                                    <td>
                                                        <ng-container *ngIf="!editShipping; else editNombreEnv">
                                                        {{ presupuesto.nombre_env || '—' }}
                                                        </ng-container>
                                                        <ng-template #editNombreEnv>
                                                        <input
                                                            class="crm-input"
                                                            type="text"
                                                            [(ngModel)]="editableBudget.nombre_env"
                                                        />
                                                        </ng-template>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Dirección de envío:</td>
                                                    <td>
                                                        <ng-container *ngIf="!editShipping; else editCalleEnv">
                                                        {{ presupuesto.calle_env || '—' }}
                                                        </ng-container>
                                                        <ng-template #editCalleEnv>
                                                        <input
                                                            class="crm-input"
                                                            type="text"
                                                            [(ngModel)]="editableBudget.calle_env"
                                                        />
                                                        </ng-template>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>

                                <div class="info-card mt-4">
                                    <div class="d-grid info-card-title">
                                        <h3>Historial de registro</h3>
                                        <div class="d-grid card-buttons-1">
                                            <div class="d-grid"><button class="btn btn-round-outline-mini" (click)="toggleSection('history')" ><img class="center-svg" [class.rotated]="!showHistorySection" src="assets/svg/arrow-up.svg"></button></div>
                                        </div>
                                    </div>
                                    <div class="info-card-detail" *ngIf="showHistorySection">
                                        <table class="info-table">
                                            <tbody>
                                                <tr>
                                                    <td>Creado por:</td>
                                                    <td>
                                                        <div class="d-flex flex-row align-items-center color-org">
                                                            <img src="assets/svg/avatar.svg" alt="">
                                                            <u>{{ presupuesto.creadoPor?.nombre + ' ' + presupuesto.creadoPor?.apellido || 'Sistema' }}</u>

                                                           </div>
                                                    </td>
                                                    <td>
                                                        {{presupuesto?.fecha_creacion | date: 'dd/MM/yyyy HH:mm'}}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Modificado por:</td>
                                                    <td>
                                                        <div class="d-flex flex-row align-items-center color-org">
                                                            <img src="assets/svg/avatar.svg" alt="">
                                                            <u>{{ presupuesto.actualizadoPor?.nombre + ' ' + presupuesto.actualizadoPor?.apellido || 'Sistema' }}</u>

                                                        </div>
                                                    </td>
                                                    <td>
                                                        {{presupuesto?.fecha_actualizacion | date: 'dd/MM/yyyy HH:mm'}}
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="prospect-info">
                        <div class="main-open-tab" style="margin-bottom:20px;">
                            <div class="open-tab-title">
                                <div class="d-grid tab-title-detail">
                                    <div><h3 class="text-semibold">Etapas</h3></div>
                                    <div class="justify-self-end">
                                        <button class="action-btn primary d-flex align-items-center" style="width: 271px; height: 38px; border-radius: 16px;" (click)="updateBudgetStatus()">
                                        <img src="assets/svg/check-icon.svg" width="20" class="me-2">
                                            Marcar etapa como completada
                                        </button>
                                    </div>
                                </div>
                                
                                <div class="d-grid progress-status mt-3">
                                    @for(item of progreso_estado; track item){
                                        <div [ngClass]="{
                                            'status-number-one' : item.estado.orden === 1 ,
                                            'status-number-two' : item.estado.orden >= 2 && item.estado.orden <= 7, 
                                            'status-number-three' : item.estado.orden >= 8,
                                            'active' : item.completado === true,
                                            'inactive' : item.completado === false || item.completado === null,
                                            'status-clicked' : markedStatus === item.estado.id_estado
                                        }" (click)="markStatus(item.estado.id_estado)">
                                            <span class="status-text">{{item.estado.nombre}}</span>
                                        </div>
                                    }
                                </div>
                            </div>
                        </div> 
                        <div class="detail-container white-bg" style="margin-top:20px;">
                            <app-nav-budget [presupuesto_id]="presupuesto?.presupuesto_id"></app-nav-budget>
                        </div>
                        </div>
                } @else {
                    <div class="no-contact-message">
                        <p>No se encontró información del contacto</p>
                    </div>
                }
            </div>
        </div>
    </div>
</div>